module.exports = __webpack_public_path__ + "assets/img/qr_code.fb573258.svg";